import { getToken, moveRepeatedOrderIdsToEnd } from "helper/common";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
// import trimmedValues from "helper/trim";
import {
    CLEAR_FORM_FIELDS_LIST,
    FIELD_DELETE_CONFIRMATION_CLOSE,
    FIELD_DELETE_CONFIRMATION_OPEN,
    FORM_FIELD_DELETE_ERROR,
    FORM_FIELD_DELETE_ERROR_CLEAR,
    FORM_FIELD_DELETE_PENDING,
    FORM_FIELDS_LIST_ERROR,
    FORM_FIELDS_LIST_ERROR_CLEAR,
    FORM_FIELDS_LIST_PENDING,
    FORM_FIELDS_UPDATE_ERROR,
    FORM_FIELDS_UPDATE_ERROR_CLEAR,
    FORM_FIELDS_UPDATE_PENDING,
    FORMULA_CREATE_DIALOG_CLOSE,
    FORMULA_CREATE_DIALOG_OPEN,
    FORMULA_EDIT_DIALOG_CLOSE,
    FORMULA_EDIT_DIALOG_OPEN,
    SELECTED_FORMULA_FIELD_FOR_CREATE,
    SELECTED_FORMULA_FIELD_FOR_EDIT,
    SET_FORM_FIELDS_LIST,
    SET_SELECTED_FORM_FIELD_INDEX
} from "./constants";
import { trimmedArrayOfObjects } from "helper/trim";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setFormFieldsList = (duplicateOrderRemovedList, formFieldsList) => ({
    type: SET_FORM_FIELDS_LIST,
    payload: { duplicateOrderRemovedList, formFieldsList }
});

export const clearFormFieldsList = () => ({
    type: CLEAR_FORM_FIELDS_LIST,
});

export const formFieldsListPending = () => ({
    type: FORM_FIELDS_LIST_PENDING
});

export const formFieldsListError = (errorMessage) => ({
    type: FORM_FIELDS_LIST_ERROR,
    payload: { errorMessage }
});

export const formFieldsListErrorClear = () => ({
    type: FORM_FIELDS_LIST_ERROR_CLEAR
});

export const getFormFieldsList = () => (dispatch) => {
    dispatch(formFieldsListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formConfiguration.getFormFieldsList(accessToken)
            .then((formFieldsList) => {
                const duplicateOrderRemovedList = moveRepeatedOrderIdsToEnd(formFieldsList["value"], "OrderIdx");
                dispatch(setFormFieldsList(duplicateOrderRemovedList, formFieldsList));
                dispatch(formFieldsListErrorClear());
                dispatch(formFieldsUpdateErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    if (err?.status) {
                        let message;
                        const { response } = err;
                        if (response?.body) {
                            message = response.body.error?.message;
                        }
                        else if (response?.text) {
                            message = response.text;
                        }
                        else {
                            message = null;
                        }
                        dispatch(formFieldsListError(message));
                    }
                }
                else {
                    dispatch(formFieldsListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| UPDATE ||---------------------------------------------------------------
export const setSelectedFormFieldIndex = (index) => ({
    type: SET_SELECTED_FORM_FIELD_INDEX,
    payload: { index }
});
export const formFieldsUpdatePending = () => ({
    type: FORM_FIELDS_UPDATE_PENDING
});

export const formFieldsUpdateError = (errorMessage) => ({
    type: FORM_FIELDS_UPDATE_ERROR,
    payload: { errorMessage }
});

export const formFieldsUpdateErrorClear = () => ({
    type: FORM_FIELDS_UPDATE_ERROR_CLEAR
});

export const updateFormFields = (formData) => (dispatch) => {
    const dataToSend = trimmedArrayOfObjects(formData)
    dispatch(formFieldsUpdatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formConfiguration.updateFormFields(accessToken, dataToSend)
            .then(() => {
                dispatch(getFormFieldsList());
                dispatch(formFieldsUpdateErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Form fields successfully updated.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formFieldsUpdateError(message));
                }
                else {
                    dispatch(formFieldsUpdateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| DELETE ||---------------------------------------------------------------
export const openDeleteConfrimationDialog = () => ({
    type: FIELD_DELETE_CONFIRMATION_OPEN,
});

export const closeDeleteConfrimationDialog = () => ({
    type: FIELD_DELETE_CONFIRMATION_CLOSE,
});
export const formFieldDeletePending = () => ({
    type: FORM_FIELD_DELETE_PENDING,
});
export const formFieldDeleteError = (errorMessage) => ({
    type: FORM_FIELD_DELETE_ERROR,
    payload: { errorMessage }
});
export const formFieldDeleteErrorClear = () => ({
    type: FORM_FIELD_DELETE_ERROR_CLEAR,
});

export const deleteFormField = (Id) => (dispatch) => {
    dispatch(formFieldDeletePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formConfiguration.deleteFormField(accessToken, Id)
            .then(() => {
                dispatch(closeDeleteConfrimationDialog());
                dispatch(getFormFieldsList());
                dispatch(formFieldDeleteErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Form fields successfully deleted.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formFieldDeleteError(message));
                }
                else {
                    dispatch(formFieldDeleteError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FORMULA CREATE DIALOG ||---------------------------------------------------------------
export const openFormulaCreateDialog = () => ({
    type: FORMULA_CREATE_DIALOG_OPEN,
});

export const closeFormulaCreateDialog = () => ({
    type: FORMULA_CREATE_DIALOG_CLOSE,
});

export const selectedFormulaFieldForCreate = (selectedData) => ({
    type: SELECTED_FORMULA_FIELD_FOR_CREATE,
    payload: { selectedData }
});

//-----------------------------|| FORMULA EDIT DIALOG ||---------------------------------------------------------------
export const openFormulaEditDialog = () => ({
    type: FORMULA_EDIT_DIALOG_OPEN,
});

export const closeFormulaEditDialog = () => ({
    type: FORMULA_EDIT_DIALOG_CLOSE,
});

export const selectedFormulaFieldForEdit = (selectedData) => ({
    type: SELECTED_FORMULA_FIELD_FOR_EDIT,
    payload: { selectedData }
});
